import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const Dashboard = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuotes();
  }, []);

  const fetchQuotes = async () => {
    try {
      const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';
      const res = await axios.get(`${API_URL}/quotes`);
      setQuotes(res.data);
    } catch (error) {
      toast.error('Failed to fetch quotes');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';
      await axios.put(`${API_URL}/quotes/${id}`, { status });
      toast.success('Status updated');
      fetchQuotes();
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  const getStatusClass = (status) => {
    return `status-badge status-${status}`;
  };

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>
      
      {loading ? (
        <div className="text-center" style={{ padding: '3rem 0', color: '#718096' }}>Loading...</div>
      ) : quotes.length === 0 ? (
        <div className="text-center" style={{ padding: '3rem 0', color: '#718096' }}>No quotes yet</div>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Company</th>
                <th>Contact</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {quotes.map((q) => (
                <tr key={q._id}>
                  <td>{q.company}</td>
                  <td>
                    {q.name}<br />
                    <span style={{ fontSize: '0.75rem', color: '#718096' }}>{q.email}</span>
                  </td>
                  <td>{q.orderType || 'N/A'}</td>
                  <td>
                    <span className={getStatusClass(q.status)}>
                      {q.status}
                    </span>
                  </td>
                  <td>
                    <select
                      onChange={(e) => updateStatus(q._id, e.target.value)}
                      value={q.status}
                      className="status-select"
                    >
                      <option value="pending">Pending</option>
                      <option value="reviewing">Reviewing</option>
                      <option value="quoted">Quoted</option>
                      <option value="accepted">Accepted</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Dashboard;